import React from "react";
import { HStack, Stack } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { LibraryAndArchive } from "./ResearchCentre/LibraryAndArchive";
import H1 from "../../Theme/Typography/H1";

const CarouselMobile = ({ data, searchsTerm, allCount, setAllCount }) => {
  return (
    <HStack>
      <Stack width={"100%"} position={"relative"} id="allslider">
        {data &&
          <>
            <Stack>
              {data.hits?.length > 0 && (
                <Stack flexDirection={"row"} gap={"15px"} p="5px" mt="5px" borderRadius={"3px"} border={"1px solid #e8e8e8"} justifyContent={"space-between"} w="100%">
                  <HStack p="5px">
                    <H1 fontSize={"14px"} fontWeight='600' lineHeight="18px">
                      {`${data.index} `}
                    </H1>
                  </HStack>
                  <HStack>
                    {data?.index !== "Research Centre" && data.count > 3 && (
                      <Link to={`/search-result?query=${encodeURIComponent(searchsTerm)}&type=${encodeURIComponent(data.index)}`}>
                      </Link>
                    )}
                  </HStack>
                </Stack>
              )}

              {data?.index === "Research Centre" && (
                <LibraryAndArchive 
                  masterlist={searchsTerm} 
                  SearchTerm={searchsTerm} 
                  setAllCount={setAllCount} 
                  allCount={allCount} 
                />
              )}
            </Stack>
          </>
        }
      </Stack>
    </HStack>
  );
};

export default CarouselMobile;

